export const setLocalStorageItem = (key: string, value: string): void => {
	window.localStorage.setItem(key, value);
};

export const getLocalStorageItem = (key: string): string | null => {
	return window.localStorage.getItem(key);
};
